// @flow

import format from './format';
import type { Param, QueryParams } from './types';

export function aboutPath(queryParams?: QueryParams = {}) {
  return format('/about', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function aboutContactDetailsPath(queryParams?: QueryParams = {}) {
  return format('/about/contact-details', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function acceptUserInvitationPath(queryParams?: QueryParams = {}) {
  return format('/invitation/accept', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function adminArchiveCancelledPath(queryParams?: QueryParams = {}) {
  return format('/admin/archive/cancelled', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function adminArchiveSucceededPath(queryParams?: QueryParams = {}) {
  return format('/admin/archive', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function adminArchiveUnknownPath(queryParams?: QueryParams = {}) {
  return format('/admin/archive/unknown-author', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function adminCateringInquiryPath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/admin/inquiries/c-:id', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function adminCateringInquiryMessagesPath(
  pathParams: {| catering_inquiry_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/admin/catering_inquiries/:catering_inquiry_id/messages',
    pathParams,
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function adminCommissionsPath(queryParams?: QueryParams = {}) {
  return format('/admin/commissions', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function adminEventRequestAnomalyReportsPath(
  pathParams: {| event_request_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/admin/inquiries/:event_request_id/anomaly_reports',
    pathParams,
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function adminExportArchivePath(queryParams?: QueryParams = {}) {
  return format('/admin/archive/export', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function adminInquiriesPath(queryParams?: QueryParams = {}) {
  return format('/admin/inquiries', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function adminMessageTemplatesPath(queryParams?: QueryParams = {}) {
  return format('/admin/message_templates', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function adminOrganizationPath(queryParams?: QueryParams = {}) {
  return format('/admin/organization', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function adminOrganizationInvoicesPath(queryParams?: QueryParams = {}) {
  return format('/admin/organization/invoices', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function adminPriceRequestPath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/admin/inquiries/:id', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function adminPriceRequestMessagesPath(
  pathParams: {| price_request_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/admin/inquiries/:price_request_id/messages',
    pathParams,
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function apiCateringInquiryPath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/api/catering/inquiries/:id', pathParams, queryParams, {
    translate: false,
    prependLocale: false
  });
}

export function apiV1ATMIndexPath(queryParams?: QueryParams = {}) {
  return format('/api/v1/atm', {}, queryParams, {
    translate: false,
    prependLocale: false
  });
}

export function apiV1ContractsPath(queryParams?: QueryParams = {}) {
  return format('/api/v1/contracts', {}, queryParams, {
    translate: false,
    prependLocale: false
  });
}

export function apiV1EventRequestPath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/api/v1/event_requests/:id', pathParams, queryParams, {
    translate: false,
    prependLocale: false
  });
}

export function apiV1ListsPath(queryParams?: QueryParams = {}) {
  return format('/api/v1/lists', {}, queryParams, {
    translate: false,
    prependLocale: false
  });
}

export function apiV1OrganizationsPath(queryParams?: QueryParams = {}) {
  return format('/api/v1/organizations', {}, queryParams, {
    translate: false,
    prependLocale: false
  });
}

export function apiV1PhoneNumberRequestsPath(queryParams?: QueryParams = {}) {
  return format('/api/v1/phone_number_requests', {}, queryParams, {
    translate: false,
    prependLocale: false
  });
}

export function apiV1UsersPath(queryParams?: QueryParams = {}) {
  return format('/api/v1/users', {}, queryParams, {
    translate: false,
    prependLocale: false
  });
}

export function apiV1VenuesPath(queryParams?: QueryParams = {}) {
  return format('/api/v1/venues', {}, queryParams, {
    translate: false,
    prependLocale: false
  });
}

export function apiV2GroupingGroupPath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/api/v2/grouping/groups/:id', pathParams, queryParams, {
    translate: false,
    prependLocale: false
  });
}

export function apiV2GroupingGroupRelatedVenuesPath(
  pathParams: {| group_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/api/v2/grouping/groups/:group_id/venues',
    pathParams,
    queryParams,
    { translate: false, prependLocale: false }
  );
}

export function apiV2GroupingGroupRelationshipsVenuesPath(
  pathParams: {| group_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/api/v2/grouping/groups/:group_id/relationships/venues',
    pathParams,
    queryParams,
    { translate: false, prependLocale: false }
  );
}

export function apiV2GroupingGroupsPath(queryParams?: QueryParams = {}) {
  return format('/api/v2/grouping/groups', {}, queryParams, {
    translate: false,
    prependLocale: false
  });
}

export function apiV2ImagePath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/api/v2/images/:id', pathParams, queryParams, {
    translate: false,
    prependLocale: false
  });
}

export function apiV2ImagesPath(queryParams?: QueryParams = {}) {
  return format('/api/v2/images', {}, queryParams, {
    translate: false,
    prependLocale: false
  });
}

export function apiV2ListingPath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/api/v2/listings/:id', pathParams, queryParams, {
    translate: false,
    prependLocale: false
  });
}

export function apiV2ListingsPath(queryParams?: QueryParams = {}) {
  return format('/api/v2/listings', {}, queryParams, {
    translate: false,
    prependLocale: false
  });
}

export function apiV2MessageTemplatePath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/api/v2/message-templates/:id', pathParams, queryParams, {
    translate: false,
    prependLocale: false
  });
}

export function apiV2MessageTemplateRelatedOrganizationPath(
  pathParams: {| message_template_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/api/v2/message-templates/:message_template_id/organization',
    pathParams,
    queryParams,
    { translate: false, prependLocale: false }
  );
}

export function apiV2MessageTemplateRelationshipsOrganizationPath(
  pathParams: {| message_template_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/api/v2/message-templates/:message_template_id/relationships/organization',
    pathParams,
    queryParams,
    { translate: false, prependLocale: false }
  );
}

export function apiV2MessageTemplatesPath(queryParams?: QueryParams = {}) {
  return format('/api/v2/message-templates', {}, queryParams, {
    translate: false,
    prependLocale: false
  });
}

export function apiV2OrganizationPath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/api/v2/organizations/:id', pathParams, queryParams, {
    translate: false,
    prependLocale: false
  });
}

export function apiV2OrganizationRelatedMessageTemplatesPath(
  pathParams: {| organization_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/api/v2/organizations/:organization_id/message-templates',
    pathParams,
    queryParams,
    { translate: false, prependLocale: false }
  );
}

export function apiV2OrganizationRelatedVenuesPath(
  pathParams: {| organization_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/api/v2/organizations/:organization_id/venues',
    pathParams,
    queryParams,
    { translate: false, prependLocale: false }
  );
}

export function apiV2OrganizationRelationshipsMessageTemplatesPath(
  pathParams: {| organization_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/api/v2/organizations/:organization_id/relationships/message-templates',
    pathParams,
    queryParams,
    { translate: false, prependLocale: false }
  );
}

export function apiV2OrganizationRelationshipsVenuesPath(
  pathParams: {| organization_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/api/v2/organizations/:organization_id/relationships/venues',
    pathParams,
    queryParams,
    { translate: false, prependLocale: false }
  );
}

export function apiV2OrganizationsPath(queryParams?: QueryParams = {}) {
  return format('/api/v2/organizations', {}, queryParams, {
    translate: false,
    prependLocale: false
  });
}

export function apiV2PackagesCelebrationPackagePath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/api/v2/packages/celebration-packages/:id',
    pathParams,
    queryParams,
    { translate: false, prependLocale: false }
  );
}

export function apiV2PackagesCelebrationPackageRelatedVenuesPath(
  pathParams: {| celebration_package_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/api/v2/packages/celebration-packages/:celebration_package_id/venues',
    pathParams,
    queryParams,
    { translate: false, prependLocale: false }
  );
}

export function apiV2PackagesCelebrationPackageRelationshipsVenuesPath(
  pathParams: {| celebration_package_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/api/v2/packages/celebration-packages/:celebration_package_id/relationships/venues',
    pathParams,
    queryParams,
    { translate: false, prependLocale: false }
  );
}

export function apiV2PackagesCelebrationPackagesPath(
  queryParams?: QueryParams = {}
) {
  return format('/api/v2/packages/celebration-packages', {}, queryParams, {
    translate: false,
    prependLocale: false
  });
}

export function apiV2PackagesExperiencePackagePath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/api/v2/packages/experience-packages/:id',
    pathParams,
    queryParams,
    { translate: false, prependLocale: false }
  );
}

export function apiV2PackagesExperiencePackageRelatedVenuesPath(
  pathParams: {| experience_package_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/api/v2/packages/experience-packages/:experience_package_id/venues',
    pathParams,
    queryParams,
    { translate: false, prependLocale: false }
  );
}

export function apiV2PackagesExperiencePackageRelationshipsVenuesPath(
  pathParams: {| experience_package_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/api/v2/packages/experience-packages/:experience_package_id/relationships/venues',
    pathParams,
    queryParams,
    { translate: false, prependLocale: false }
  );
}

export function apiV2PackagesExperiencePackagesPath(
  queryParams?: QueryParams = {}
) {
  return format('/api/v2/packages/experience-packages', {}, queryParams, {
    translate: false,
    prependLocale: false
  });
}

export function apiV2PackagesMeetingPackagePath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/api/v2/packages/meeting-packages/:id',
    pathParams,
    queryParams,
    { translate: false, prependLocale: false }
  );
}

export function apiV2PackagesMeetingPackageRelatedServicesPath(
  pathParams: {| meeting_package_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/api/v2/packages/meeting-packages/:meeting_package_id/services',
    pathParams,
    queryParams,
    { translate: false, prependLocale: false }
  );
}

export function apiV2PackagesMeetingPackageRelatedVenuesPath(
  pathParams: {| meeting_package_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/api/v2/packages/meeting-packages/:meeting_package_id/venues',
    pathParams,
    queryParams,
    { translate: false, prependLocale: false }
  );
}

export function apiV2PackagesMeetingPackageRelationshipsServicesPath(
  pathParams: {| meeting_package_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/api/v2/packages/meeting-packages/:meeting_package_id/relationships/services',
    pathParams,
    queryParams,
    { translate: false, prependLocale: false }
  );
}

export function apiV2PackagesMeetingPackageRelationshipsVenuesPath(
  pathParams: {| meeting_package_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/api/v2/packages/meeting-packages/:meeting_package_id/relationships/venues',
    pathParams,
    queryParams,
    { translate: false, prependLocale: false }
  );
}

export function apiV2PackagesMeetingPackagesPath(
  queryParams?: QueryParams = {}
) {
  return format('/api/v2/packages/meeting-packages', {}, queryParams, {
    translate: false,
    prependLocale: false
  });
}

export function apiV2PackagesServicePath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/api/v2/packages/services/:id', pathParams, queryParams, {
    translate: false,
    prependLocale: false
  });
}

export function apiV2PackagesServicesPath(queryParams?: QueryParams = {}) {
  return format('/api/v2/packages/services', {}, queryParams, {
    translate: false,
    prependLocale: false
  });
}

export function apiV2PackagesVenuePackagePath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/api/v2/packages/venue-packages/:id',
    pathParams,
    queryParams,
    { translate: false, prependLocale: false }
  );
}

export function apiV2PackagesVenuePackageRelatedServicesPath(
  pathParams: {| venue_package_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/api/v2/packages/venue-packages/:venue_package_id/services',
    pathParams,
    queryParams,
    { translate: false, prependLocale: false }
  );
}

export function apiV2PackagesVenuePackageRelatedVenuesPath(
  pathParams: {| venue_package_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/api/v2/packages/venue-packages/:venue_package_id/venues',
    pathParams,
    queryParams,
    { translate: false, prependLocale: false }
  );
}

export function apiV2PackagesVenuePackageRelationshipsServicesPath(
  pathParams: {| venue_package_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/api/v2/packages/venue-packages/:venue_package_id/relationships/services',
    pathParams,
    queryParams,
    { translate: false, prependLocale: false }
  );
}

export function apiV2PackagesVenuePackageRelationshipsVenuesPath(
  pathParams: {| venue_package_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/api/v2/packages/venue-packages/:venue_package_id/relationships/venues',
    pathParams,
    queryParams,
    { translate: false, prependLocale: false }
  );
}

export function apiV2PackagesVenuePackagesPath(queryParams?: QueryParams = {}) {
  return format('/api/v2/packages/venue-packages', {}, queryParams, {
    translate: false,
    prependLocale: false
  });
}

export function apiV2VenuePath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/api/v2/venues/:id', pathParams, queryParams, {
    translate: false,
    prependLocale: false
  });
}

export function apiV2VenueRelatedCelebrationPackagesPath(
  pathParams: {| venue_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/api/v2/venues/:venue_id/celebration-packages',
    pathParams,
    queryParams,
    { translate: false, prependLocale: false }
  );
}

export function apiV2VenueRelatedExperiencePackagesPath(
  pathParams: {| venue_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/api/v2/venues/:venue_id/experience-packages',
    pathParams,
    queryParams,
    { translate: false, prependLocale: false }
  );
}

export function apiV2VenueRelatedGroupsPath(
  pathParams: {| venue_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/api/v2/venues/:venue_id/groups', pathParams, queryParams, {
    translate: false,
    prependLocale: false
  });
}

export function apiV2VenueRelatedMainImagePath(
  pathParams: {| venue_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/api/v2/venues/:venue_id/main-image',
    pathParams,
    queryParams,
    { translate: false, prependLocale: false }
  );
}

export function apiV2VenueRelatedMeetingPackagesPath(
  pathParams: {| venue_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/api/v2/venues/:venue_id/meeting-packages',
    pathParams,
    queryParams,
    { translate: false, prependLocale: false }
  );
}

export function apiV2VenueRelatedOrganizationPath(
  pathParams: {| venue_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/api/v2/venues/:venue_id/organization',
    pathParams,
    queryParams,
    { translate: false, prependLocale: false }
  );
}

export function apiV2VenueRelatedSiblingVenuesPath(
  pathParams: {| venue_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/api/v2/venues/:venue_id/sibling-venues',
    pathParams,
    queryParams,
    { translate: false, prependLocale: false }
  );
}

export function apiV2VenueRelatedVenuePackagesPath(
  pathParams: {| venue_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/api/v2/venues/:venue_id/venue-packages',
    pathParams,
    queryParams,
    { translate: false, prependLocale: false }
  );
}

export function apiV2VenueRelationshipsCelebrationPackagesPath(
  pathParams: {| venue_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/api/v2/venues/:venue_id/relationships/celebration-packages',
    pathParams,
    queryParams,
    { translate: false, prependLocale: false }
  );
}

export function apiV2VenueRelationshipsExperiencePackagesPath(
  pathParams: {| venue_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/api/v2/venues/:venue_id/relationships/experience-packages',
    pathParams,
    queryParams,
    { translate: false, prependLocale: false }
  );
}

export function apiV2VenueRelationshipsGroupsPath(
  pathParams: {| venue_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/api/v2/venues/:venue_id/relationships/groups',
    pathParams,
    queryParams,
    { translate: false, prependLocale: false }
  );
}

export function apiV2VenueRelationshipsMainImagePath(
  pathParams: {| venue_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/api/v2/venues/:venue_id/relationships/main-image',
    pathParams,
    queryParams,
    { translate: false, prependLocale: false }
  );
}

export function apiV2VenueRelationshipsMeetingPackagesPath(
  pathParams: {| venue_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/api/v2/venues/:venue_id/relationships/meeting-packages',
    pathParams,
    queryParams,
    { translate: false, prependLocale: false }
  );
}

export function apiV2VenueRelationshipsOrganizationPath(
  pathParams: {| venue_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/api/v2/venues/:venue_id/relationships/organization',
    pathParams,
    queryParams,
    { translate: false, prependLocale: false }
  );
}

export function apiV2VenueRelationshipsSiblingVenuesPath(
  pathParams: {| venue_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/api/v2/venues/:venue_id/relationships/sibling-venues',
    pathParams,
    queryParams,
    { translate: false, prependLocale: false }
  );
}

export function apiV2VenueRelationshipsVenuePackagesPath(
  pathParams: {| venue_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/api/v2/venues/:venue_id/relationships/venue-packages',
    pathParams,
    queryParams,
    { translate: false, prependLocale: false }
  );
}

export function apiV2VenuesPath(queryParams?: QueryParams = {}) {
  return format('/api/v2/venues', {}, queryParams, {
    translate: false,
    prependLocale: false
  });
}

export function autocompleteProfilesVenueProfilesPath(
  queryParams?: QueryParams = {}
) {
  return format('/venues/autocomplete', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function autocompleteStaffProspectsPath(queryParams?: QueryParams = {}) {
  return format('/staff/prospects/autocomplete', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function ballinPath(queryParams?: QueryParams = {}) {
  return format('/ballin', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function batchStaffInvoicesPath(queryParams?: QueryParams = {}) {
  return format('/staff/invoices/batch', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function blogPostPath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/blog/:id', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function blogPostsPath(queryParams?: QueryParams = {}) {
  return format('/blog', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function blogTagPath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/blog/hashtag/:id', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function cancelUserRegistrationPath(queryParams?: QueryParams = {}) {
  return format('/cancel', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function cateringConversationReplyEmailsPath(
  queryParams?: QueryParams = {}
) {
  return format(
    '/webhooks/catering_conversation_reply_emails',
    {},
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function cateringLandingPagePath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/:id', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function cateringListYourServicePath(queryParams?: QueryParams = {}) {
  return format('/catering/list-your-service', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function cateringProfileInquiriesPath(
  pathParams: {| profile_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/catering/:profile_id/inquiries', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function cateringProfileMenusPath(
  pathParams: {| profile_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/catering/:profile_id/menus', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function cateringSearchPath(queryParams?: QueryParams = {}) {
  return format('/catering', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function conversationReplyEmailsPath(queryParams?: QueryParams = {}) {
  return format('/webhooks/conversation_reply_emails', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function dashboardPath(queryParams?: QueryParams = {}) {
  return format('/dashboard', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function destroyUserSessionPath(queryParams?: QueryParams = {}) {
  return format('/logout', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function disableFeatureStaffOrganizationPath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/staff/organizations/:id/disable_feature',
    pathParams,
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function duplicateListPath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/lists/:id/duplicate', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function duplicateStaffLandingPagePath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/staff/landing_pages/:id/duplicate', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function editAdminOrganizationPath(queryParams?: QueryParams = {}) {
  return format('/admin/organization/edit', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function editAdminPackagesPath(queryParams?: QueryParams = {}) {
  return format('/admin/packages/edit', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function editGroupsPath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/venues/:id/groups/edit', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function editPackagesPath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/venues/:id/packages/edit', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function editProfilesCateringProfilePath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/catering/:id/edit', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function editProfilesReviewPath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/reviews/:id/edit', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function editProfilesSupplierProfilePath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/supplier/:id/edit', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function editProfilesVenueProfilePath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/venues/:id/edit', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function editReviewPath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/reviews/:id/edit', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function editStaffCateringLandingPagePath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/staff/catering_landing_pages/:id/edit',
    pathParams,
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function editStaffCateringServiceAreaCityPath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/staff/catering/service_area_cities/:id/edit',
    pathParams,
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function editStaffInvoicePath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/staff/invoices/:id/edit', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function editStaffLandingPagePath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/staff/landing_pages/:id/edit', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function editStaffOrganizationPath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/staff/organizations/:id/edit', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function editStaffOrganizationContractPath(
  pathParams: {| organization_id: Param, id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/staff/organizations/:organization_id/contracts/:id/edit',
    pathParams,
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function editStaffOrganizationServiceFeePath(
  pathParams: {| organization_id: Param, id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/staff/organizations/:organization_id/service_fees/:id/edit',
    pathParams,
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function editStaffUserPath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/staff/users/:id/edit', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function editStaffVenuePath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/staff/venues/:id/edit', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function editStaffVenueRelevanceScoresPath(
  pathParams: {| venue_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/staff/venues/:venue_id/relevance_scores/edit',
    pathParams,
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function editUserPasswordPath(queryParams?: QueryParams = {}) {
  return format('/password/edit', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function editUserRegistrationPath(queryParams?: QueryParams = {}) {
  return format('/edit', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function enableFeatureStaffOrganizationPath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/staff/organizations/:id/enable_feature',
    pathParams,
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function eventConsultationPath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/event_consultations/:id', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function examplePath(queryParams?: QueryParams = {}) {
  return format('/example', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function exportAskForReviewsStaffCSVExportsPath(
  queryParams?: QueryParams = {}
) {
  return format('/staff/csv_exports/export_ask_for_reviews', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function exportEventRequestsStaffCSVExportsPath(
  queryParams?: QueryParams = {}
) {
  return format('/staff/csv_exports/export_event_requests', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function exportNonResponsiveAssigneesStaffCSVExportsPath(
  queryParams?: QueryParams = {}
) {
  return format(
    '/staff/csv_exports/export_non_responsive_assignees',
    {},
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function exportNotRespondedPriceRequestsStaffCSVExportsPath(
  queryParams?: QueryParams = {}
) {
  return format(
    '/staff/csv_exports/export_not_responded_price_requests',
    {},
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function exportOrganizationsStaffCSVExportsPath(
  queryParams?: QueryParams = {}
) {
  return format('/staff/csv_exports/export_organizations', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function exportUsersStaffCSVExportsPath(queryParams?: QueryParams = {}) {
  return format('/staff/csv_exports/export_users', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function exportVenuesStaffCSVExportsPath(
  queryParams?: QueryParams = {}
) {
  return format('/staff/csv_exports/export_venues', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function feedbackPath(queryParams?: QueryParams = {}) {
  return format('/feedback', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function indexPath(queryParams?: QueryParams = {}) {
  return format('/index', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function innerCirclePath(queryParams?: QueryParams = {}) {
  return format('/inner-circle', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function inquiriesSupplierProfileSupplierInquiriesPath(
  pathParams: {| supplier_profile_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/supplier/:supplier_profile_id/inquiries',
    pathParams,
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function instructionsICalPath(queryParams?: QueryParams = {}) {
  return format('/instructions/ical', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function instructionsReplyInServiceFaqPath(
  queryParams?: QueryParams = {}
) {
  return format('/instructions/reply-in-service-faq', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function instructionsReportBookingsPath(queryParams?: QueryParams = {}) {
  return format('/instructions/report-bookings', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function kisakatsomoskabanVoittajaPath(queryParams?: QueryParams = {}) {
  return format('/kisakatsomoskaban-voittaja', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function landingPagePath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/:id', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function listPath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/lists/:id', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function listsPath(queryParams?: QueryParams = {}) {
  return format('/lists', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function manageVenuesPath(queryParams?: QueryParams = {}) {
  return format('/dashboard/venues', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function markAsRepliedAdminPriceRequestPath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/admin/inquiries/:id/mark_as_replied',
    pathParams,
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function newListPath(queryParams?: QueryParams = {}) {
  return format('/lists/new', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function newPriceRequestPath(queryParams?: QueryParams = {}) {
  return format('/price_requests/new', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function newProfilesCateringProfileReviewPath(
  pathParams: {| catering_profile_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/catering/:catering_profile_id/reviews/new',
    pathParams,
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function newProfilesVenueProfileReviewPath(
  pathParams: {| venue_profile_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/venues/:venue_profile_id/reviews/new',
    pathParams,
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function newStaffCateringLandingPagePath(
  queryParams?: QueryParams = {}
) {
  return format('/staff/catering_landing_pages/new', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function newStaffInvoicePath(queryParams?: QueryParams = {}) {
  return format('/staff/invoices/new', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function newStaffLandingPagePath(queryParams?: QueryParams = {}) {
  return format('/staff/landing_pages/new', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function newStaffOrganizationPath(queryParams?: QueryParams = {}) {
  return format('/staff/organizations/new', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function newStaffOrganizationContractPath(
  pathParams: {| organization_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/staff/organizations/:organization_id/contracts/new',
    pathParams,
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function newStaffOrganizationServiceFeePath(
  pathParams: {| organization_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/staff/organizations/:organization_id/service_fees/new',
    pathParams,
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function newStaffVenuePath(queryParams?: QueryParams = {}) {
  return format('/staff/venues/new', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function newUserInvitationPath(queryParams?: QueryParams = {}) {
  return format('/invitation/new', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function newUserPasswordPath(queryParams?: QueryParams = {}) {
  return format('/password/new', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function newUserRegistrationPath(queryParams?: QueryParams = {}) {
  return format('/register', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function newUserSessionPath(queryParams?: QueryParams = {}) {
  return format('/login', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function newVenueOwnerFormPath(queryParams?: QueryParams = {}) {
  return format('/register-venue-owner', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function newVenueOwnerRegistrationPath(queryParams?: QueryParams = {}) {
  return format('/add-your-venue', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function newVenueReviewPath(
  pathParams: {| venue_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/venues/:venue_id/reviews/new', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function newsletterSubscriptionsPath(queryParams?: QueryParams = {}) {
  return format('/newsletter_subscriptions', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function pitopalveluPath(queryParams?: QueryParams = {}) {
  return format('/pitopalvelu', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function pitopalveluEspooPath(queryParams?: QueryParams = {}) {
  return format('/pitopalvelu-espoo', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function pitopalveluHelsinkiPath(queryParams?: QueryParams = {}) {
  return format('/pitopalvelu-helsinki', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function pitopalveluTamperePath(queryParams?: QueryParams = {}) {
  return format('/pitopalvelu-tampere', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function pitopalveluTurkuPath(queryParams?: QueryParams = {}) {
  return format('/pitopalvelu-turku', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function pitopalveluVantaaPath(queryParams?: QueryParams = {}) {
  return format('/pitopalvelu-vantaa', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function priceRequestsPath(queryParams?: QueryParams = {}) {
  return format('/price_requests', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function privacyPolicyPath(queryParams?: QueryParams = {}) {
  return format('/privacy-policy', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function profilesCateringProfilePath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/catering/:id', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function profilesCateringProfileImagesPath(
  pathParams: {| catering_profile_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/catering/:catering_profile_id/images',
    pathParams,
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function profilesCateringProfileReviewsPath(
  pathParams: {| catering_profile_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/catering/:catering_profile_id/reviews',
    pathParams,
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function profilesCateringProfilesPath(queryParams?: QueryParams = {}) {
  return format('/catering', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function profilesReviewPath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/reviews/:id', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function profilesSupplierProfilePath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/supplier/:id', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function profilesSupplierProfileImagesPath(
  pathParams: {| supplier_profile_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/supplier/:supplier_profile_id/images',
    pathParams,
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function profilesSupplierProfilesPath(queryParams?: QueryParams = {}) {
  return format('/supplier', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function profilesVenueProfilePath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/venues/:id', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function profilesVenueProfilePublishPath(
  pathParams: {| venue_profile_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/venues/:venue_profile_id/publish', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function profilesVenueProfileReviewsPath(
  pathParams: {| venue_profile_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/venues/:venue_profile_id/reviews', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function profilesVenueProfileTransferPath(
  pathParams: {| venue_profile_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/venues/:venue_profile_id/transfer', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function profilesVenueProfileUnpublishPath(
  pathParams: {| venue_profile_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/venues/:venue_profile_id/unpublish',
    pathParams,
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function profilesVenueProfilesPath(queryParams?: QueryParams = {}) {
  return format('/venues', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function railsBlobRepresentationPath(
  pathParams: {|
    signed_blob_id: Param,
    variation_key: Param,
    filename: Param
  |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/rails/active_storage/representations/:signed_blob_id/:variation_key/:filename',
    pathParams,
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function railsDirectUploadsPath(queryParams?: QueryParams = {}) {
  return format('/rails/active_storage/direct_uploads', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function railsDiskServicePath(
  pathParams: {| encoded_key: Param, filename: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/rails/active_storage/disk/:encoded_key/:filename',
    pathParams,
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function railsEventStoreBrowserPath(queryParams?: QueryParams = {}) {
  return format('/rails_event_store', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function railsInfoPath(queryParams?: QueryParams = {}) {
  return format('/rails/info', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function railsInfoPropertiesPath(queryParams?: QueryParams = {}) {
  return format('/rails/info/properties', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function railsInfoRoutesPath(queryParams?: QueryParams = {}) {
  return format('/rails/info/routes', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function railsMailersPath(queryParams?: QueryParams = {}) {
  return format('/rails/mailers', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function railsServiceBlobPath(
  pathParams: {| signed_id: Param, filename: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/rails/active_storage/blobs/:signed_id/:filename',
    pathParams,
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function reactivateStaffEventRequestPath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/staff/event_requests/:id/reactivate',
    pathParams,
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function removeUserInvitationPath(queryParams?: QueryParams = {}) {
  return format('/invitation/remove', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function reviewPath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/reviews/:id', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function robotsPath(queryParams?: QueryParams = {}) {
  return format('/robots.txt', {}, queryParams, {
    translate: false,
    prependLocale: false
  });
}

export function rootPath(queryParams?: QueryParams = {}) {
  return format('/', {}, queryParams, { translate: true, prependLocale: true });
}

export function ruisrockLippujenVoittajaPath(queryParams?: QueryParams = {}) {
  return format('/ruisrock-lippujen-voittaja', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function saveListEventConsultationPath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/event_consultations/:id/save_list', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function sendCopyToAuthorPriceRequestPath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/price_requests/:id/send-copy', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function sidekiqWebPath(queryParams?: QueryParams = {}) {
  return format('/sidekiq', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function staffCateringPath(queryParams?: QueryParams = {}) {
  return format('/staff/catering', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function staffCateringLandingPagePath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/staff/catering_landing_pages/:id', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function staffCateringLandingPagesPath(queryParams?: QueryParams = {}) {
  return format('/staff/catering_landing_pages', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function staffCateringProfileTransferPath(
  pathParams: {| profile_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/staff/catering/profiles/:profile_id/transfer',
    pathParams,
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function staffCateringServiceAreaCitiesPath(
  queryParams?: QueryParams = {}
) {
  return format('/staff/catering/service_area_cities', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function staffCateringServiceAreaCityPath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/staff/catering/service_area_cities/:id',
    pathParams,
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function staffCSVExportsPath(queryParams?: QueryParams = {}) {
  return format('/staff/csv_exports', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function staffFeaturedVenuesPath(queryParams?: QueryParams = {}) {
  return format('/staff/featured_venues', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function staffImagePath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/staff/images/:id', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function staffImagesPath(queryParams?: QueryParams = {}) {
  return format('/staff/images', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function staffInvoicePath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/staff/invoices/:id', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function staffInvoicesPath(queryParams?: QueryParams = {}) {
  return format('/staff/invoices', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function staffLandingPagePath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/staff/landing_pages/:id', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function staffLandingPagesPath(queryParams?: QueryParams = {}) {
  return format('/staff/landing_pages', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function staffMetricsPath(queryParams?: QueryParams = {}) {
  return format('/staff/metrics', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function staffOrganizationPath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/staff/organizations/:id', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function staffOrganizationContractPath(
  pathParams: {| organization_id: Param, id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/staff/organizations/:organization_id/contracts/:id',
    pathParams,
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function staffOrganizationContractsPath(
  pathParams: {| organization_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/staff/organizations/:organization_id/contracts',
    pathParams,
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function staffOrganizationCrmNotesPath(
  pathParams: {| organization_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/staff/organizations/:organization_id/crm_notes',
    pathParams,
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function staffOrganizationProfileAnnouncementsPath(
  pathParams: {| organization_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/staff/organizations/:organization_id/profile_announcements',
    pathParams,
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function staffOrganizationServiceFeePath(
  pathParams: {| organization_id: Param, id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/staff/organizations/:organization_id/service_fees/:id',
    pathParams,
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function staffOrganizationServiceFeesPath(
  pathParams: {| organization_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/staff/organizations/:organization_id/service_fees',
    pathParams,
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function staffOrganizationsPath(queryParams?: QueryParams = {}) {
  return format('/staff/organizations', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function staffPriceRequestsPath(queryParams?: QueryParams = {}) {
  return format('/staff/price_requests', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function staffProspectsPath(queryParams?: QueryParams = {}) {
  return format('/staff/prospects', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function staffReferralCookiePath(queryParams?: QueryParams = {}) {
  return format('/staff/referral_cookie', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function staffReferralReportingGeneratedReportPath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/staff/referral_reporting/generated_reports/:id',
    pathParams,
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function staffReferralReportingGeneratedReportsPath(
  queryParams?: QueryParams = {}
) {
  return format(
    '/staff/referral_reporting/generated_reports',
    {},
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function staffReferralReportingReportPath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/staff/referral_reporting/reports/:id',
    pathParams,
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function staffReferralReportingReportsPath(
  queryParams?: QueryParams = {}
) {
  return format('/staff/referral_reporting/reports', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function staffReferralReportingRootPath(queryParams?: QueryParams = {}) {
  return format('/staff/referral_reporting', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function staffResendMessagePath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/staff/resend_messages/:id', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function staffSpamReviewPath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/staff/spam_reviews/:id', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function staffSpamReviewsPath(queryParams?: QueryParams = {}) {
  return format('/staff/spam_reviews', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function staffSpamReviewsRecoverPath(queryParams?: QueryParams = {}) {
  return format('/staff/spam_reviews/recover', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function staffUserPath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/staff/users/:id', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function staffUsersPath(queryParams?: QueryParams = {}) {
  return format('/staff/users', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function staffVenuePath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/staff/venues/:id', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function staffVenueFeaturedEventTypesPath(
  pathParams: {| venue_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/staff/venues/:venue_id/featured_event_types',
    pathParams,
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function staffVenueRelevanceScoresPath(
  pathParams: {| venue_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/staff/venues/:venue_id/relevance_scores',
    pathParams,
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function staffVenuesPath(queryParams?: QueryParams = {}) {
  return format('/staff/venues', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function staffWorkbenchesPath(queryParams?: QueryParams = {}) {
  return format('/staff/workbenches', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function staffWorkbenchesRelevanceVisualizationPath(
  queryParams?: QueryParams = {}
) {
  return format('/staff/workbenches/relevance_visualization', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function staffWorkbenchesSimilarityVisualizationPath(
  queryParams?: QueryParams = {}
) {
  return format(
    '/staff/workbenches/similarity_visualization',
    {},
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function styleguidePath(queryParams?: QueryParams = {}) {
  return format('/styleguide', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function thanksEventConsultationPath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/event_consultations/:id/thanks', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function thanksPriceRequestsPath(queryParams?: QueryParams = {}) {
  return format('/price_requests/thanks', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function toggleBookingInquiryStaffVenuePath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/staff/venues/:id/toggle_booking_inquiry',
    pathParams,
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function transferStaffOrganizationPath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/staff/organizations/:id/transfer', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function turkuPath(queryParams?: QueryParams = {}) {
  return format('/turku', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function updateNoteListPath(
  pathParams: {| id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/lists/:id/update_note', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function updateRailsDiskServicePath(
  pathParams: {| encoded_token: Param |},
  queryParams?: QueryParams = {}
) {
  return format(
    '/rails/active_storage/disk/:encoded_token',
    pathParams,
    queryParams,
    { translate: true, prependLocale: true }
  );
}

export function userInvitationPath(queryParams?: QueryParams = {}) {
  return format('/invitation', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function userPasswordPath(queryParams?: QueryParams = {}) {
  return format('/password', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function userRegistrationPath(queryParams?: QueryParams = {}) {
  return format('/', {}, queryParams, { translate: true, prependLocale: true });
}

export function userSessionPath(queryParams?: QueryParams = {}) {
  return format('/login', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function venueReviewsPath(
  pathParams: {| venue_id: Param |},
  queryParams?: QueryParams = {}
) {
  return format('/venues/:venue_id/reviews', pathParams, queryParams, {
    translate: true,
    prependLocale: true
  });
}

export function venuesPath(queryParams?: QueryParams = {}) {
  return format('/venues', {}, queryParams, {
    translate: true,
    prependLocale: true
  });
}
